// extracted by mini-css-extract-plugin
export var lock = "h_y";
export var qr = "h_z";